import React from "react";
import { getImageBlob } from "../../helpers";

export function useBlobUrl(blobKey: string | null | undefined) {
  const [url, setUrl] = React.useState("");

  React.useEffect(() => {
    if (!blobKey) {
      setUrl("");
      return;
    }

    // Si ya es una URL válida, usarla directamente
    if (
      blobKey.startsWith("http://") ||
      blobKey.startsWith("https://") ||
      blobKey.startsWith("data:")
    ) {
      setUrl(blobKey);
      return;
    }

    let isActive = true;
    let objectUrl: string | null = null; // ← Cambio importante

    (async () => {
      try {
        const blob = await getImageBlob(blobKey);
        
        if (!blob) {
          console.warn(`⚠️ [useBlobUrl] Blob no encontrado: ${blobKey}`);
          if (isActive) setUrl("");
          return;
        }

        if (!isActive) return; // Componente desmontado antes de terminar

        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      } catch (error) {
        console.error(`❌ [useBlobUrl] Error cargando blob ${blobKey}:`, error);
        if (isActive) setUrl("");
      }
    })();

    // Cleanup
    return () => {
      isActive = false;
      if (objectUrl) {
        URL.revokeObjectURL(objectUrl);
        console.log(`🗑️ [useBlobUrl] Revocado: ${objectUrl}`);
      }
    };
  }, [blobKey]);

  return url;
}

async function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      resolve(reader.result as string);
    };
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });
}

export async function obtenerFotoConWatermarkBase64(
  key: string | null
): Promise<string> {
  if (!key) return "";
  
  try {
    const blob = await getImageBlob(key);
    if (!blob) {
      console.warn(`⚠️ [watermark] Blob no encontrado: ${key}`);
      return "";
    }
    
    const base64 = await blobToBase64(blob);
    return base64;
  } catch (error) {
    console.error(`❌ [watermark] Error procesando ${key}:`, error);
    return "";
  }
}